function ErrorFallback() {
  return <div>ErrorFallback</div>;
}

export default ErrorFallback;
